import UserPermissions from '../../../../permissions/constants/userPermissions';
import { VisitDeletedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import getAppEnv from '../../utils/getAppEnv';
import { deletedVisitSuccessNotification } from '../../../../notifications/visits';
import { SchedulingQueryParams } from '../../Router/constants';
import { getCustomerOrderReturn } from '../../../../components/customerProfiles/customerOrderNavigation';

export default ({ store, id, name }: VisitDeletedDtoModelType) => () => {
  const rootStore = getAppRoot(store);
  if (id == null) return;

  const visit = rootStore.model.visitDtos.get(id);
  const visitUuid = visit?.uuid;
  const visitName = name || visit?.activeLocation?.displayAddress;

  rootStore.model.customerOrderDtos.get(id)?.markDeleted();
  rootStore.model.visitDtos.delete(id);

  if (visitUuid && rootStore.router.queryParams.get(SchedulingQueryParams.ORDER) === visitUuid) {
    const destination = getCustomerOrderReturn(rootStore.router.location?.state);
    if (destination) rootStore.router.replace(destination);
    else rootStore.router.replaceQueryParams({ [SchedulingQueryParams.ORDER]: null }, true);
  }

  if (rootStore.ui.selectedWorkspace?.id != null && rootStore.account.hasPermission(UserPermissions.DELETE_VISITS)) {
    getAppEnv(store).notification(deletedVisitSuccessNotification(id, visitName));
  }
};
